export enum PingStatus {
    ConnectionLost = "ConnectionLost",
    Online = "Online"
}